'use client'

import { createContext, useContext } from 'react'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { BcmLogo } from '@/components/BcmLogo'
import './AppVolver.css'

/*
 * La flecha para volver a /apps adentro de la app, en vez de en una banda vacía arriba (Fede, 2026-10-22: «está feo
 * todo este espacio»). El page.jsx de la ruta envuelve la app en <AppVolverProvider value={goHome}> y la app pone
 * <BcmLogoConVolver /> donde iba el logo de su menú, o <AppVolverBoton /> al lado de su título. Sin provider no
 * cambia nada. Con menos de 1024 px la flecha se esconde: ahí la ruta sigue con su banda y su .apps-back-button.
 */
const VolverContext = createContext(null)

export const AppVolverProvider = VolverContext.Provider

export function AppVolverBoton() {
  const volver = useContext(VolverContext)
  const { t } = useTranslation()
  if (!volver) return null
  return (
    <button
      type="button"
      className="app-volver"
      onClick={volver}
      aria-label={t('apps:gate.back_to_apps')}
      title={t('apps:gate.back_to_apps')}
    >
      <ArrowLeft size={20} aria-hidden="true" />
    </button>
  )
}

/** @param {{ style?: import('react').CSSProperties }} props */
export function BcmLogoConVolver({ style }) {
  const volver = useContext(VolverContext)
  if (!volver) return <BcmLogo style={style} />
  return (
    <div className="app-volver-logo">
      <AppVolverBoton />
      <BcmLogo style={style} />
    </div>
  )
}
